import { NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { ClampJoint, ClampJointTypeEnum } from 'cloud-shared-lib';

export interface CountertopLinesConnectorBottomSheetComponentData {
  connectors: ClampJoint[];
  title: string;
}

@Component({
  selector: 'csl-bottom-sheet-overview-example-sheet',
  template: `
    <div class="text-2xl font-medium p-4">{{ title }}</div>
    <mat-selection-list [multiple]="false">
      <mat-list-option *ngFor="let item of view" (click)="selectConnector(item.connector)">
        <span mat-line>{{ item.name }}</span>
        <span mat-line class="secondary-text">{{ item.description }}</span>
      </mat-list-option>
    </mat-selection-list>
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatLegacyListModule, NgFor],
})
export class CountertopLinesConnectorBottomSheetComponent {
  private _bottomSheetRef = inject<MatBottomSheetRef<CountertopLinesConnectorBottomSheetComponent>>(MatBottomSheetRef);

  data: CountertopLinesConnectorBottomSheetComponentData = inject(MAT_BOTTOM_SHEET_DATA);
  connectors = this.data.connectors;
  title = this.data.title ?? $localize`Выберите тип стяжки`;

  view = this.connectors.map(c => ({
    name: $localize`Тип ${c.type + 1}`,
    description: $localize`Длина: ${this.getConnectorTotalLength(c)} мм; Высота: ${c.h} мм; Ширина: ${Math.max(
      c.b,
      c.d
    )} мм; Диаметр отверстий: ${c.d} мм; Смещение от края: ${c.edgeOffset} мм`,
    connector: c,
  }));

  getConnectorTotalLength(item: ClampJoint): number {
    switch (item.type) {
      case ClampJointTypeEnum.Type1:
        return item.l + item.d;

      case ClampJointTypeEnum.Type2:
        return item.l2 + item.b;

      default:
        return 0;
    }
  }

  selectConnector(connector: ClampJoint): void {
    this._bottomSheetRef.dismiss(connector);
  }
}
